module.exports = __webpack_public_path__ + "img/icon-pay-default.cdd3edcb.svg";